/**
 * Enum for WorkItem Assignment Type
 */
export enum WorkItemAssignmentTypes {

    /** 
    * While creating WorkItem, Author would be a default assignment
    */
    AUTHOR = "7924ad1b-8807-4802-8095-a742ef2ead48"
}
